import { AsyncStoreItem } from 'src/lib';
import { PostTravelersStandByTravelersResponse } from 'src/sdk_checkin';

/**
 * GetStandbyTravelersResult model
 */
export interface GetStandbyTravelersResultModel {
  model: PostTravelersStandByTravelersResponse | null;
}

/**
 * PostTravelersStandByTravelersResponse model details
 */
export interface GetStandbyTravelersResultStateDetails extends AsyncStoreItem {}

/**
 * GetStandbyTravelersResult store state
 */
export interface GetStandbyTravelersResultState
  extends GetStandbyTravelersResultStateDetails,
    GetStandbyTravelersResultModel {}

/**
 * Name of the GetStandbyTravelersResult Store
 */
export const GET_STANDBY_TRAVELERS_RESULT_STORE_NAME = 'getStandbyTravelersResult';

/**
 * GetStandbyTravelersResult Store Interface
 */
export interface GetStandbyTravelersResultStore {
  /** GetStandbyTravelersResult state */
  [GET_STANDBY_TRAVELERS_RESULT_STORE_NAME]: GetStandbyTravelersResultState;
}
